import { Image } from 'antd';
import { Header as AntHeader } from 'antd/es/layout/layout';
import { useSelector } from 'react-redux';
import { RootState } from '../../configureStore';
import useIsMobile from '../../utils/useIsMobile';

const Header = ({ logo: defaultLogo, isTest = false }: { logo?: string; isTest?: boolean; }) => {
    const logo = useSelector<RootState, string>(({ configuration }) => configuration.logo);
    const isMobile = useIsMobile();

    return (
        <AntHeader className={`${isMobile ? 'px-2' : 'px-8'} flex-center-start row`}>
            <Image
                src={isTest ? (defaultLogo ?? '/logo.png') : logo}
                preview={false}
                id='logo-img'
                alt="Logo"
                style={{
                    height: 40
                }}
            />
        </AntHeader>
    );
};

export default Header;
